/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuditRecordRequest,
    AuditRecordRequestFromJSON,
    AuditRecordRequestFromJSONTyped,
    AuditRecordRequestToJSON,
    BrandAndMarketRequest,
    BrandAndMarketRequestFromJSON,
    BrandAndMarketRequestFromJSONTyped,
    BrandAndMarketRequestToJSON,
    CabinCriteriaRequest,
    CabinCriteriaRequestFromJSON,
    CabinCriteriaRequestFromJSONTyped,
    CabinCriteriaRequestToJSON,
    CharCriteriaRequest,
    CharCriteriaRequestFromJSON,
    CharCriteriaRequestFromJSONTyped,
    CharCriteriaRequestToJSON,
    CriteriaForBookingDateTimeRequest,
    CriteriaForBookingDateTimeRequestFromJSON,
    CriteriaForBookingDateTimeRequestFromJSONTyped,
    CriteriaForBookingDateTimeRequestToJSON,
    CriteriaForLocationRequest,
    CriteriaForLocationRequestFromJSON,
    CriteriaForLocationRequestFromJSONTyped,
    CriteriaForLocationRequestToJSON,
    CriteriaForRouteRequest,
    CriteriaForRouteRequestFromJSON,
    CriteriaForRouteRequestFromJSONTyped,
    CriteriaForRouteRequestToJSON,
    DateTimeCriteriaRangeRequest,
    DateTimeCriteriaRangeRequestFromJSON,
    DateTimeCriteriaRangeRequestFromJSONTyped,
    DateTimeCriteriaRangeRequestToJSON,
    EffectiveDateRangeRequest,
    EffectiveDateRangeRequestFromJSON,
    EffectiveDateRangeRequestFromJSONTyped,
    EffectiveDateRangeRequestToJSON,
    FareTypesCriteriaRequest,
    FareTypesCriteriaRequestFromJSON,
    FareTypesCriteriaRequestFromJSONTyped,
    FareTypesCriteriaRequestToJSON,
    Int32CriteriaRangeRequest,
    Int32CriteriaRangeRequestFromJSON,
    Int32CriteriaRangeRequestFromJSONTyped,
    Int32CriteriaRangeRequestToJSON,
    MarkupPriority,
    MarkupPriorityFromJSON,
    MarkupPriorityFromJSONTyped,
    MarkupPriorityToJSON,
    PriceBandRequestCriteriaRequest,
    PriceBandRequestCriteriaRequestFromJSON,
    PriceBandRequestCriteriaRequestFromJSONTyped,
    PriceBandRequestCriteriaRequestToJSON,
    SalesJourneyCriteriaRequest,
    SalesJourneyCriteriaRequestFromJSON,
    SalesJourneyCriteriaRequestFromJSONTyped,
    SalesJourneyCriteriaRequestToJSON,
    StringCriteriaRangeRequest,
    StringCriteriaRangeRequestFromJSON,
    StringCriteriaRangeRequestFromJSONTyped,
    StringCriteriaRangeRequestToJSON,
    StringCriteriaRequest,
    StringCriteriaRequestFromJSON,
    StringCriteriaRequestFromJSONTyped,
    StringCriteriaRequestToJSON,
    SystemContextRequest,
    SystemContextRequestFromJSON,
    SystemContextRequestFromJSONTyped,
    SystemContextRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupEditRequest
 */
export interface MarkupEditRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkupEditRequest
     */
    markupId?: string;
    /**
     * 
     * @type {BrandAndMarketRequest}
     * @memberof MarkupEditRequest
     */
    brandMarket?: BrandAndMarketRequest;
    /**
     * 
     * @type {Array<StringCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    accountCodes?: Array<StringCriteriaRequest> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupEditRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<CharCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    bookingClasses?: Array<CharCriteriaRequest> | null;
    /**
     * 
     * @type {Array<CriteriaForBookingDateTimeRequest>}
     * @memberof MarkupEditRequest
     */
    bookingDateTimes?: Array<CriteriaForBookingDateTimeRequest> | null;
    /**
     * 
     * @type {Array<PriceBandRequestCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    bookingPriceBands?: Array<PriceBandRequestCriteriaRequest> | null;
    /**
     * 
     * @type {Array<CabinCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    cabinClasses?: Array<CabinCriteriaRequest> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupEditRequest
     */
    description: string;
    /**
     * 
     * @type {Array<StringCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    fareBasisCodes?: Array<StringCriteriaRequest> | null;
    /**
     * 
     * @type {Array<FareTypesCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    fareTypes?: Array<FareTypesCriteriaRequest> | null;
    /**
     * 
     * @type {Array<StringCriteriaRangeRequest>}
     * @memberof MarkupEditRequest
     */
    flightNumbers?: Array<StringCriteriaRangeRequest> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupEditRequest
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupEditRequest
     */
    isExclusionRule?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupEditRequest
     */
    includeTax?: boolean;
    /**
     * 
     * @type {Array<SalesJourneyCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    journeyTypes?: Array<SalesJourneyCriteriaRequest> | null;
    /**
     * 
     * @type {Array<CriteriaForLocationRequest>}
     * @memberof MarkupEditRequest
     */
    locations?: Array<CriteriaForLocationRequest> | null;
    /**
     * 
     * @type {Array<StringCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    marketingAirlines?: Array<StringCriteriaRequest> | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupEditRequest
     */
    markupAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkupEditRequest
     */
    markupPercentage?: number;
    /**
     * 
     * @type {Array<Int32CriteriaRangeRequest>}
     * @memberof MarkupEditRequest
     */
    passengerAges?: Array<Int32CriteriaRangeRequest> | null;
    /**
     * 
     * @type {MarkupPriority}
     * @memberof MarkupEditRequest
     */
    priority?: MarkupPriority;
    /**
     * 
     * @type {Array<CriteriaForRouteRequest>}
     * @memberof MarkupEditRequest
     */
    routes?: Array<CriteriaForRouteRequest> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupEditRequest
     */
    suppliers?: Array<string> | null;
    /**
     * 
     * @type {SystemContextRequest}
     * @memberof MarkupEditRequest
     */
    systemContext?: SystemContextRequest;
    /**
     * 
     * @type {Array<StringCriteriaRequest>}
     * @memberof MarkupEditRequest
     */
    ticketDesignators?: Array<StringCriteriaRequest> | null;
    /**
     * 
     * @type {Array<DateTimeCriteriaRangeRequest>}
     * @memberof MarkupEditRequest
     */
    travelDateTimes?: Array<DateTimeCriteriaRangeRequest> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupEditRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupEditRequest
     */
    deleted?: boolean;
    /**
     * 
     * @type {EffectiveDateRangeRequest}
     * @memberof MarkupEditRequest
     */
    effectiveDateRange?: EffectiveDateRangeRequest;
    /**
     * 
     * @type {AuditRecordRequest}
     * @memberof MarkupEditRequest
     */
    auditRecord?: AuditRecordRequest;
}

export function MarkupEditRequestFromJSON(json: any): MarkupEditRequest {
    return MarkupEditRequestFromJSONTyped(json, false);
}

export function MarkupEditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupEditRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'markupId': !exists(json, 'markupId') ? undefined : json['markupId'],
        'brandMarket': !exists(json, 'brandMarket') ? undefined : BrandAndMarketRequestFromJSON(json['brandMarket']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(StringCriteriaRequestFromJSON)),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(CharCriteriaRequestFromJSON)),
        'bookingDateTimes': !exists(json, 'bookingDateTimes') ? undefined : (json['bookingDateTimes'] === null ? null : (json['bookingDateTimes'] as Array<any>).map(CriteriaForBookingDateTimeRequestFromJSON)),
        'bookingPriceBands': !exists(json, 'bookingPriceBands') ? undefined : (json['bookingPriceBands'] === null ? null : (json['bookingPriceBands'] as Array<any>).map(PriceBandRequestCriteriaRequestFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinCriteriaRequestFromJSON)),
        'description': json['description'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : (json['fareBasisCodes'] === null ? null : (json['fareBasisCodes'] as Array<any>).map(StringCriteriaRequestFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(FareTypesCriteriaRequestFromJSON)),
        'flightNumbers': !exists(json, 'flightNumbers') ? undefined : (json['flightNumbers'] === null ? null : (json['flightNumbers'] as Array<any>).map(StringCriteriaRangeRequestFromJSON)),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'isExclusionRule': !exists(json, 'isExclusionRule') ? undefined : json['isExclusionRule'],
        'includeTax': !exists(json, 'includeTax') ? undefined : json['includeTax'],
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(SalesJourneyCriteriaRequestFromJSON)),
        'locations': !exists(json, 'locations') ? undefined : (json['locations'] === null ? null : (json['locations'] as Array<any>).map(CriteriaForLocationRequestFromJSON)),
        'marketingAirlines': !exists(json, 'marketingAirlines') ? undefined : (json['marketingAirlines'] === null ? null : (json['marketingAirlines'] as Array<any>).map(StringCriteriaRequestFromJSON)),
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'passengerAges': !exists(json, 'passengerAges') ? undefined : (json['passengerAges'] === null ? null : (json['passengerAges'] as Array<any>).map(Int32CriteriaRangeRequestFromJSON)),
        'priority': !exists(json, 'priority') ? undefined : MarkupPriorityFromJSON(json['priority']),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(CriteriaForRouteRequestFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : json['suppliers'],
        'systemContext': !exists(json, 'systemContext') ? undefined : SystemContextRequestFromJSON(json['systemContext']),
        'ticketDesignators': !exists(json, 'ticketDesignators') ? undefined : (json['ticketDesignators'] === null ? null : (json['ticketDesignators'] as Array<any>).map(StringCriteriaRequestFromJSON)),
        'travelDateTimes': !exists(json, 'travelDateTimes') ? undefined : (json['travelDateTimes'] === null ? null : (json['travelDateTimes'] as Array<any>).map(DateTimeCriteriaRangeRequestFromJSON)),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effectiveDateRange': !exists(json, 'effectiveDateRange') ? undefined : EffectiveDateRangeRequestFromJSON(json['effectiveDateRange']),
        'auditRecord': !exists(json, 'auditRecord') ? undefined : AuditRecordRequestFromJSON(json['auditRecord']),
    };
}

export function MarkupEditRequestToJSON(value?: MarkupEditRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'markupId': value.markupId,
        'brandMarket': BrandAndMarketRequestToJSON(value.brandMarket),
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(StringCriteriaRequestToJSON)),
        'comment': value.comment,
        'bookingClasses': value.bookingClasses === undefined ? undefined : (value.bookingClasses === null ? null : (value.bookingClasses as Array<any>).map(CharCriteriaRequestToJSON)),
        'bookingDateTimes': value.bookingDateTimes === undefined ? undefined : (value.bookingDateTimes === null ? null : (value.bookingDateTimes as Array<any>).map(CriteriaForBookingDateTimeRequestToJSON)),
        'bookingPriceBands': value.bookingPriceBands === undefined ? undefined : (value.bookingPriceBands === null ? null : (value.bookingPriceBands as Array<any>).map(PriceBandRequestCriteriaRequestToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinCriteriaRequestToJSON)),
        'description': value.description,
        'fareBasisCodes': value.fareBasisCodes === undefined ? undefined : (value.fareBasisCodes === null ? null : (value.fareBasisCodes as Array<any>).map(StringCriteriaRequestToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(FareTypesCriteriaRequestToJSON)),
        'flightNumbers': value.flightNumbers === undefined ? undefined : (value.flightNumbers === null ? null : (value.flightNumbers as Array<any>).map(StringCriteriaRangeRequestToJSON)),
        'isDeleted': value.isDeleted,
        'isExclusionRule': value.isExclusionRule,
        'includeTax': value.includeTax,
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(SalesJourneyCriteriaRequestToJSON)),
        'locations': value.locations === undefined ? undefined : (value.locations === null ? null : (value.locations as Array<any>).map(CriteriaForLocationRequestToJSON)),
        'marketingAirlines': value.marketingAirlines === undefined ? undefined : (value.marketingAirlines === null ? null : (value.marketingAirlines as Array<any>).map(StringCriteriaRequestToJSON)),
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'passengerAges': value.passengerAges === undefined ? undefined : (value.passengerAges === null ? null : (value.passengerAges as Array<any>).map(Int32CriteriaRangeRequestToJSON)),
        'priority': MarkupPriorityToJSON(value.priority),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(CriteriaForRouteRequestToJSON)),
        'suppliers': value.suppliers,
        'systemContext': SystemContextRequestToJSON(value.systemContext),
        'ticketDesignators': value.ticketDesignators === undefined ? undefined : (value.ticketDesignators === null ? null : (value.ticketDesignators as Array<any>).map(StringCriteriaRequestToJSON)),
        'travelDateTimes': value.travelDateTimes === undefined ? undefined : (value.travelDateTimes === null ? null : (value.travelDateTimes as Array<any>).map(DateTimeCriteriaRangeRequestToJSON)),
        'enabled': value.enabled,
        'deleted': value.deleted,
        'effectiveDateRange': EffectiveDateRangeRequestToJSON(value.effectiveDateRange),
        'auditRecord': AuditRecordRequestToJSON(value.auditRecord),
    };
}


